import React from 'react'
import connect from "react-redux/es/connect/connect"
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/AddCircle'
import RemoveIcon from '@material-ui/icons/RemoveCircle'

import styles from 'common/components/style'


import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'

import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ToggleIconButton from "common/components/ToggleIconButton";
import {
  buildingChooserConfirm,
  buildingChooserDone,
  buildingChooserGetConfirmationSummary,
  buildingChooserValidateSet
} from "redux/admin/Actions";



class BuildingChooserDialogClass extends React.Component {

  render() {
    if (!this.props.buildings) return null

    const { buildings, confirmationSummary, buildingChooserGetConfirmationSummary, buildingChooserDone, buildingChooserConfirm, buildingChooserValidateSet, classes,  } = this.props

    return (
      <Dialog
        onClose={buildingChooserDone}
        aria-labelledby="customized-dialog-title"
        open
      >
        <DialogTitle id="customized-dialog-title" onClose={buildingChooserDone}>
          Buildings used by SchoolTRAK
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
          {confirmationSummary
            ? 
            <>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                <AddIcon style={{ marginRight: 8, color: '#757575' }} />
                <Typography variant="h6">Buildings to be Enabled</Typography>
              </div>
              {confirmationSummary.enableBuildings.length === 0
                ?
                <Typography style={{ paddingLeft: 16 }}>No buildings to be enabled.</Typography>
                :
                <List>
                  {confirmationSummary.enableBuildings.map((building) => {
                    return <ListItem key={building.id} style={{ display: 'block' }}>
                      <div>{building.displayName}</div>
                      {building.affectedLocationsCount || building.affectedKiosksCount ?
                        (
                          <List>
                            <ListItem>
                              <span style={{ whiteSpace: 'nowrap' }}>Locations to be re-enabled: {building.affectedLocationsCount}</span>
                            </ListItem>
                            <ListItem>
                              <span style={{ whiteSpace: 'nowrap' }}>Kiosks to be re-enabled: {building.affectedKiosksCount}</span>
                            </ListItem>
                          </List>
                        ) : null
                      }
                    </ListItem>
                  })}
                </List>
              }
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                <RemoveIcon style={{ marginRight: 8, color: '#757575' }} />
                <Typography variant="h6">Buildings to be Disabled</Typography>
              </div>
              {confirmationSummary.disableBuildings.length === 0
                ?
                <Typography style={{ paddingLeft: 16 }}>No buildings to be disabled.</Typography>
                :
                <>
                  <List>
                    {confirmationSummary.disableBuildings.map((building) => {
                      return (
                        <ListItem key={building.id} style={{ display: 'block' }}>
                          <div>{building.displayName}</div>
                          <List>
                            <ListItem>
                              <span style={{ whiteSpace: 'nowrap' }}>Locations to be disabled: {building.affectedLocationsCount}</span>
                            </ListItem>
                            <ListItem>
                              <span style={{ whiteSpace: 'nowrap' }}>Kiosks to be disabled: {building.affectedKiosksCount}</span>
                            </ListItem>
                          </List>
                        </ListItem>
                      )
                    })}
                  </List>
                  <Typography style={{ paddingLeft: 16, color: '#d32f2f' }}>Buildings, associated locations, and kiosks will be disabled. They will be deleted during the next school year migration.</Typography>
                </>
              }
            </>
            :
            <>
              <List>
                {buildings.map((building) => {
                  return <ListItem key={building.id}><ToggleIconButton isOn={building.isEnabled} onClick={() => buildingChooserValidateSet({ id: building.id, isEnabled: !building.isEnabled })} />{building.displayName}</ListItem>
                })}
              </List>
            </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={buildingChooserDone} color="secondary">
            Cancel
          </Button>
          {confirmationSummary
            ? 
            <>
              <Button onClick={buildingChooserConfirm} color="primary">
                Confirm
              </Button>
            </>
            :
            <>
              <Button onClick={buildingChooserGetConfirmationSummary} color="primary">
                Next
              </Button>
            </>
          }
        </DialogActions>
      </Dialog>
    )
  }
}

export const BuildingChooserDialog = connect(
  state => state.admin.buildingChooser,
  {
    buildingChooserConfirm,
    buildingChooserValidateSet,
    buildingChooserDone,
    buildingChooserGetConfirmationSummary
  }
)(withStyles(styles, { withTheme: true })(BuildingChooserDialogClass))

export default BuildingChooserDialog
